import DiffMatchPatch from 'diff-match-patch';
import DiffSymbolEnum from '../../../constants/contract_diff/diff_symbol';
import dayjs from 'dayjs';

export function getOpenWindowProperties() {
  const properties =
    'width=1280,height=720' +
    ',left=' +
    (window.screenX + window.innerWidth / 2 - 640) +
    ',top=' +
    (window.screenTop + 50) +
    ',directories=no,titlebar=no,toolbar=no,location=no,status=no,menubar=no,scrollbars=yes,resizable=yes,';
  return properties;
}

export function normalizeSpace(text) {
  // What: normalize_text - スペースを統一
  // https://en.wikipedia.org/wiki/Whitespace_character
  const SPACE_CHAR_LIST = [
    '\u0020',
    '\u00A0',
    '\u2000',
    '\u2001',
    '\u2002',
    '\u2003',
    '\u2004',
    '\u2005',
    '\u2006',
    '\u2007',
    '\u2008',
    '\u205F'
  ];
  const NORMALIZED_SPACE = ' ';

  for (const replaceChar of SPACE_CHAR_LIST) {
    text = text.replace(replaceChar, NORMALIZED_SPACE);
  }
  return text;
}

export function normalizeNewLine(text) {
  // What: normalize_text - 改行を統一
  // \r = CR (Carriage Return) → Used as a new line character in Mac OS before X
  // \n = LF (Line Feed) → Used as a new line character in Unix/Mac OS X
  // \r\n = CR + LF → Used as a new line character in Windows
  return text.replace('\r\n', '\n').replace('\r', '\n');
}

export function getTextDiff(text1, text2) {
  // 参照：https://www.npmjs.com/package/diff-match-patch
  // What: Libraryを使って文書比較をする
  // 注意: 使い側で異常系をtry.catch...で扱うメソッドである
  const dmp = new DiffMatchPatch();
  const diff = dmp.diff_main(text1, text2);
  dmp.diff_cleanupSemantic(diff);
  return diff;
}

export function changeDiffResult(result) {
  // 行合わせが失敗した際に、diffMatchPatchの結果を表示用形式に切り替える
  return [result];
}

export function getCurrentDateTimeText() {
  return dayjs(new Date()).format('YYYYMMDDHHmm');
}

export function createFileName(file1Name, file2Name) {
  return `${getCurrentDateTimeText()}_${file1Name}_${file2Name}_テキスト結果.xlsx`;
}



// WEBPACK FOOTER //
// ./src/functions/pages/contract_diff/index.js